export const millisecondsPerStep = 100;
export const fixedDelay = 400;
export const sendInterval = 1000;

export type GetTimeCallback = () => number;

export const DefaultGetTime: GetTimeCallback = () => {
    return Date.now();
};

export const StepPayloadType = "step";

export type StepPayload = {
    type: string;
    time: number;
    step: number;
};
